<form class="mce-form-section">

    <div class="mce-form-field-group">

        <div class="mce-form-field-group">

            <div>
                <mat-form-field>
                    <mat-label>O/C setting</mat-label>
                    <input matInput type="number" placeholder="O/C setting"
                           [formField]="form().ioc" />
                    <span matSuffix>A</span>
                    @for (error of form().ioc().errors(); track error.kind ) {
                    <mat-error> {{ error.message }} </mat-error> }
                </mat-form-field>
            </div>

        </div>

    </div>

</form>
